export default __webpack_public_path__ + "static/media/copyright-violation.cbe561e6.svg";